import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  Table, TableBody, TableCell, TableHead, TableRow,
  TextField, Typography
} from '@mui/material';
import Box from '@mui/material/Box';
import removeButton from '../../../icons/remove.png';
import * as React from 'react';
import { useEffect } from 'react';
import axios from 'axios';
import { getApiBaseUrl } from '../../../utils/env';
import { ReactComponent as PencilIcon } from '../../../icons/pencil.svg';
import { Organisation } from '../../types/organisation';

const removeOrgMedia = async (id: number) => {
  await axios.delete(`${getApiBaseUrl()}/organisation-mrss-media/${id}`);
};

type MediaItem = {
  id: number,
  url: string,
  enabled: boolean,
}

const fetchOrgMedia = async (domain) => {
  const { data } = await axios.get(`${getApiBaseUrl()}/organisation-mrss-media/${domain}/list`);
  return data;
};

const addOrgMedia = async (
  org_id: number,
  url: string,
  enabled: boolean
) => {
  await axios.post(`${getApiBaseUrl()}/organisation-mrss-media`, {
    org_id,
    url,
    enabled,
  });
};

const editOrgMedia = async (
  id: number,
  org_id: number,
  url: string,
  enabled: boolean,
) => {
  await axios.patch(`${getApiBaseUrl()}/organisation-mrss-media/${id}`, {
    id,
    org_id,
    url,
    enabled,
  });
};

export const MRSSMediaImporter = ({ organisation }: { organisation: Organisation }) => {
  const [url, setUrl] = React.useState('');
  const [enabled, setEnabled] = React.useState(false);
  const [selectedId, setSelectedId] = React.useState<number>();

  const [medias, setMedias] = React.useState<MediaItem[]>([]);

  const reset = () => {
    setUrl('');
    setEnabled(false);
    setSelectedId(undefined);
  };

  useEffect(() => {
    fetchOrgMedia(organisation.domain).then((results) => {
      setMedias(results);
    });
  }, [organisation.domain]);
  return (<Grid container spacing={2} style={{ marginTop: 0 }}>
    <Grid item xs={4}>
      <form onSubmit={(e) => {
        e.preventDefault();
        if (selectedId) {
          editOrgMedia(selectedId, organisation.id as number, url, enabled)
            .then(() => {
              fetchOrgMedia(organisation.domain).then((results) => {
                setMedias(results);
                reset();
              });
            });
        } else {
          addOrgMedia(organisation.id as number, url, enabled)
            .then(() => {
              fetchOrgMedia(organisation.domain).then((results) => {
                setMedias(results);
                reset();
              });
            });
        }
      }}>
        <Grid container spacing={2} style={{ marginTop: 0 }}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField required value={url} id="URL" label="Channel URL"
                         variant="outlined"
                         type={'url'} onChange={(e) => setUrl(e.target.value)}/>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl fullWidth>
              <FormControlLabel
                control={<Checkbox checked={enabled}
                                   onChange={(e) => setEnabled(e.target.checked)}/>}
                label="Enabled"
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Grid container justifyContent={'space-between'}>
              <Button variant="outlined" onClick={() => reset()}>Reset</Button>
              <Button variant="contained" type={'submit'} color="primary">Save</Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </Grid>
    <Grid item xs={8}>
      {medias.length === 0 && (<Typography>No saved item yet</Typography>)}
      {medias.length > 0 && (<Table>
        <TableHead>
          <TableRow>
            <TableCell>URL</TableCell>
            <TableCell>Enabled</TableCell>
            <TableCell>Edit</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {medias.map((media) => (
            <TableRow key={media.id}>
              <TableCell><Box title={media.url} sx={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '400px',
              }}>{media.url}</Box></TableCell>
              <TableCell>{media.enabled ? 'Yes' : 'No'}</TableCell>
              <TableCell>
                <Grid container justifyContent={'space-around'} spacing={1}>
                  <Grid item>
                    <PencilIcon style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  setUrl(media.url);
                                  setEnabled(media.enabled);
                                  setSelectedId(media.id);
                                }}
                    />
                  </Grid>
                  <Grid item>
                      <span onClick={async () => {
                        if (window.confirm('Are you sure you want to remove this config?')) {
                          await removeOrgMedia(media.id);
                          fetchOrgMedia(organisation.domain).then((results) => {
                            setMedias(results);
                          });
                        }
                      }} style={{ cursor: 'pointer' }}><img
                        width={20}
                        src={removeButton}
                        alt="Remove config"/></span>
                  </Grid>
                </Grid>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>)}

    </Grid>
  </Grid>);
};